import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  PaperClipOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Tooltip,
  Upload,
} from 'antd'
import React, { useCallback } from 'react'
import { useRef } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent'
import commonStore from '../../../stores/commonStore'
import validator from '../../../validator'
import {
  UploadFileListItem,
  UploadFileListWrapper,
} from '../../ConnectedDocumentOutgoingDocCreatePage/ConnectedDocumentOutgoingDocCreatePageStyled'
import {
  FileListItem,
  FileListWrapper,
} from '../../RiskDetailPage/RiskDetailPageStyled'
import fileStore from '../../../stores/fileStore'

const { TextArea } = Input

const RiskTemplateCreateModal = ({
  showCreateModal,
  handleCancelCreateModal,
  type,
  riskTemplateStore,
  loadRiskTemplateList,
  handleCancelEditModal,
  risk,
  setEditRisk,
}) => {
  const { Option } = Select
  const { createRiskTemplate, updateRiskTemplate } = riskTemplateStore
  const [form] = Form.useForm()
  const CAUSE_REF = useRef()
  const MEASURE_REF = useRef()
  const [isRenderRichText, setIsRenderRichText] = useState(false)
  const [fileList, setFileList] = useState([])
  const [fileUploadedList, setFileUploadedList] = useState([])

  useEffect(() => {
    if (!risk) {
      return
    }
    form.setFieldsValue({
      rui_ro_nhan_dien: risk.rui_ro_nhan_dien,
      linh_vuc_hoat_dong: risk?.linh_vuc_hoat_dong
        ? risk?.linh_vuc_hoat_dong
        : null,
      type: risk.type,
    })
    setFileUploadedList(risk?.attachments)
  }, [form, risk])

  const [buttonBlock, setButtonBlock] = useState(false)

  useEffect(() => {
    if (showCreateModal) {
      setTimeout(() => {
        setIsRenderRichText(true)
      }, 400)
    } else {
      setIsRenderRichText(false)
    }
  }, [showCreateModal])

  const handleChangeFile = useCallback(
    info => {
      if (risk) {
        const newFileList = info.fileList
        const filteredFileList = newFileList.filter(
          (elem, index, fileArray) =>
            fileArray.findIndex(file => file.name === elem.name) === index
        )

        const finalFileList = filteredFileList.filter(file => {
          const isDuplicate = fileUploadedList.some(
            uploadedFile => uploadedFile.file_name === file.name
          )
          if (isDuplicate) {
            message.warning(`File "${file.name}" đã tồn tại`)
            return false
          }
          return true
        })

        setFileList(finalFileList)
      } else {
        const filteredFileList = info.fileList.filter(
          (elem, index, fileArray) =>
            fileArray.findIndex(file => file.name === elem.name) === index
        )
        setFileList(filteredFileList)
      }
    },
    [fileUploadedList]
  )

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const handleCreateRisk = async value => {
    setButtonBlock(true)
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const response = await Promise.all(batchUploadArr)
    const fileIds = risk
      ? response
          .map(r => r.data.file_id)
          .concat(fileUploadedList.map(f => f.file_id))
      : response.map(r => r.data.file_id)
    const submitData = {
      linh_vuc_hoat_dong: value.linh_vuc_hoat_dong,
      rui_ro_nhan_dien: value.rui_ro_nhan_dien,
      nguyen_nhan: CAUSE_REF.current.editor.getData(),
      bien_phap_phong_ngua_giam_thieu: MEASURE_REF.current.editor.getData(),
      type: value.type,
      attachments: fileIds,
    }
    try {
      risk
        ? await updateRiskTemplate(risk.id, submitData)
        : await createRiskTemplate(submitData)
      await loadRiskTemplateList()
      risk
        ? message.success('Cập nhật thành công')
        : message.success('Tạo mới thành công')
      handleCancelCreateModal()
      setFileList([])
      setFileUploadedList(risk?.attachments)
      setEditRisk(null)
    } catch {
      message.error('Đã có lỗi xảy ra')
    }
  }
  const { riskTemplateTypes } = riskTemplateStore

  return (
    <Modal
      visible={showCreateModal}
      footer={null}
      destroyOnClose={true}
      afterClose={() => {
        setButtonBlock(false)
        setIsRenderRichText(false)
      }}
      width={600}
      onCancel={() => {
        ;(risk ? handleCancelEditModal : handleCancelCreateModal)()
        setFileList([])
        setFileUploadedList(risk?.attachments)
      }}
      title={
        <>
          <ExclamationCircleOutlined
            style={{
              color: commonStore.appTheme.solidColor,
              marginRight: 10,
            }}
          />
          {risk ? 'Cập nhật rủi ro nhận diện' : 'Tạo mới rủi ro nhận diện'}
        </>
      }>
      <Form
        layout={'vertical'}
        onFinish={handleCreateRisk}
        preserve={false}
        form={form}
        initialValues={{
          rui_ro_nhan_dien: risk?.rui_ro_nhan_dien,
          linh_vuc_hoat_dong: risk?.linh_vuc_hoat_dong
            ? risk?.linh_vuc_hoat_dong
            : null,
          type: risk?.type,
        }}>
        <Form.Item
          label={'Loại'}
          name={'type'}
          rules={[{ required: true, message: 'Vui lòng chọn !' }]}>
          <Select
            style={{ minWidth: '250px' }}
            placeholder={'Chọn loại'}
            allowClear
            showSearch
            filterOption={(input, option) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={risk ? true : false}>
            {riskTemplateTypes?.length > 0 &&
              riskTemplateTypes.map(type => (
                <Option key={type.code} value={type.code}>
                  {type.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item
          label={'Lĩnh vực hoạt động'}
          name={'linh_vuc_hoat_dong'}
          rules={[
            { required: true, message: 'Vui lòng nhập !' },
            { validator: validator.validateInputString },
          ]}>
          <Input placeholder={'Nhập lĩnh vực hoạt động'} />
        </Form.Item>
        <Form.Item
          label={'Rủi ro nhận diện'}
          name={'rui_ro_nhan_dien'}
          rules={[
            { required: true, message: 'Vui lòng nhập !' },
            { validator: validator.validateInputString },
          ]}>
          <TextArea rows={3} placeholder={'Nhập rủi ro nhận diện'} />
        </Form.Item>
        <Form.Item label={'Tài liệu đính kèm:'} name={'id_file_dinh_kem'}>
          <Upload
            valuePropName={'fileList'}
            fileList={fileList}
            multiple={true}
            onChange={handleChangeFile}
            beforeUpload={() => false}
            showUploadList={false}>
            <Button htmlType={'button'}>
              <UploadOutlined />
              Chọn tài liệu đính kèm
            </Button>
          </Upload>
        </Form.Item>
        {fileList.length !== 0 && (
          <UploadFileListWrapper>
            {fileList.map(file => (
              <UploadFileListItem key={file.uid}>
                <FileTextOutlined />
                <span>{file.name}</span>
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    onClick={() => handleRemoveFileFromUploadList(file.uid)}
                  />
                </Tooltip>
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
        )}
        {fileUploadedList && fileUploadedList.length !== 0 && (
          <FileListWrapper>
            {fileUploadedList.map(file => (
              <FileListItem key={file.file_id}>
                <PaperClipOutlined />
                <span>{file.file_name}</span>
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    onClick={() =>
                      setFileUploadedList(
                        fileUploadedList.filter(
                          el => el.file_id !== file.file_id
                        )
                      )
                    }
                  />
                </Tooltip>
              </FileListItem>
            ))}
          </FileListWrapper>
        )}
        <Form.Item label={'Nguyên nhân'} name={'nguyen_nhan'}>
          {!isRenderRichText && (
            <div style={{ height: 312, position: 'relative' }}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                tip="Đang tải dữ liệu..."
                isLoading={!isRenderRichText}
                backGround={'#ffffffc7'}
              />
            </div>
          )}
          {isRenderRichText && (
            <RichEditor
              EDITOR_REF={CAUSE_REF}
              placeholder={'Nhập nội dung...'}
              editorContent={risk?.nguyen_nhan}
            />
          )}
        </Form.Item>
        <Form.Item
          label={'Biện pháp phòng ngừa giảm thiểu'}
          name={'bien_phap_phong_ngua_giam_thieu'}>
          {!isRenderRichText && (
            <div style={{ height: 312, position: 'relative' }}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                tip="Đang tải dữ liệu..."
                isLoading={!isRenderRichText}
                backGround={'#ffffffc7'}
              />
            </div>
          )}
          {isRenderRichText && (
            <RichEditor
              EDITOR_REF={MEASURE_REF}
              placeholder={'Nhập nội dung...'}
              editorContent={risk?.bien_phap_phong_ngua_giam_thieu}
            />
          )}
        </Form.Item>
        <Row justify={'end'}>
          <Space>
            <Button
              onClick={risk ? handleCancelEditModal : handleCancelCreateModal}>
              Hủy
            </Button>
            <Button
              disabled={buttonBlock ? true : false}
              type={'primary'}
              htmlType={'submit'}>
              {risk ? 'Cập nhật' : 'Tạo mới'}
            </Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  )
}

export default RiskTemplateCreateModal
